// @flow
import * as React from 'react';

import { connect } from 'react-redux';
import SourceLoaderComponent from '.';
import { getSourcesData } from '../../../list/selectors';
import { startHideSourcesLoaderTimer } from '../../actions';

const CHANGE_SOURCE_INTERVAL_TIME = 350;

type Props = {
  sources: Array<Source>,
  startHideSourcesLoaderTimer: Function,
};

type State = {
  currentSourceIndex: number,
  isSticky: boolean,
};

type MapDispatchToProps = {
  startHideSourcesLoaderTimer: Function,
};

type MapStateToProps = {
  sources: Array<Source>,
};

class SourceLoader extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);

    this.loaderRef = React.createRef();
    // $FlowFixMe
    this.spyScroll = this.spyScroll.bind(this);
    this.stickyLimitTrigger = null;
  }

  state = {
    isSticky: false,
    currentSourceIndex: 0,
  };

  componentDidMount() {
    const { current } = this.loaderRef;

    this.changeSourceInterval();
    this.props.startHideSourcesLoaderTimer();

    this.stickyLimitTrigger = current.offsetTop;
    this.updateIsSticky();

    window.addEventListener('scroll', this.spyScroll);
  }

  componentWillUnmount() {
    clearInterval(this.handleInterval);
    window.removeEventListener('scroll', this.spyScroll);
  }

  stickyLimitTrigger: ?number;

  loaderRef: React.ElementRef<*>;

  handleInterval: IntervalID;

  changeSourceInterval() {
    const { sources } = this.props;

    this.handleInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.currentSourceIndex === sources.length - 1) {
          return { ...prevState, currentSourceIndex: 0 };
        }

        return { ...prevState, currentSourceIndex: prevState.currentSourceIndex + 1 };
      });
    }, CHANGE_SOURCE_INTERVAL_TIME);
  }

  spyScroll() {
    this.updateIsSticky();
  }

  updateIsSticky() {
    this.setState({
      isSticky: window.pageYOffset > this.stickyLimitTrigger,
    });
  }

  render() {
    return <SourceLoaderComponent loaderRef={this.loaderRef} {...this.props} {...this.state} />;
  }
}

const mapDispatchToProps: MapDispatchToProps = {
  startHideSourcesLoaderTimer,
};

function mapStateToProps(state: Object): MapStateToProps {
  return {
    sources: getSourcesData(state),
  };
}

const SourceLoaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SourceLoader);

SourceLoaderContainer.displayName = 'SourceLoaderContainer';

export default SourceLoaderContainer;



// WEBPACK FOOTER //
// ./app/Sources/loader/components/SourceLoader/container.js